import React from "react"

function GamesLanding() {
    return <div className="gamesLanding">
        <h1>Games</h1>
        <p>Here at Funovus, our designers take great ownership of their games and make bold decisions frequently. This creative freedom lets us explore unique art styles and gameplay and helps us build better games.</p>
    </div>
}

export default GamesLanding